export default __webpack_public_path__ + "static/media/analytics-logo-placeholder.cb999831.png";